module.exports = __webpack_public_path__ + "img/delete.c5253718.svg";